// Feature flag constants to be used throughout the application
// This provides a centralized place to manage feature flag names
// and reduces the risk of typos when using feature flags

const FEATURES = {
  // Settings feature flags
  SETTING: {

  },

  // Asset Register
  ASSET_REGISTER: {
    TREE_VIEW: 'Feature.AssetRegister.TreeView',
  },
};

// Aliases for backward compatibility or convenient shortcuts
export const FEATURE_FLAGS = {
  SITE_ASSET_REGISTER_TREE_VIEW: FEATURES.ASSET_REGISTER.TREE_VIEW,
}; 